/*
 * jQuery inquiry v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, DUNLOP){
	const mapSite = DUNLOP.va.pathname.split('/')[1];

	// 生年月日セレクト
	const setSelectDateBirth = () => {
		const thisDate = new Date();
		const thisYear = thisDate.getFullYear();

		const setDateOption = () => {
			$('.js-selectBirth-day').find('option').each((idx, ele) => { $(ele).remove(); });
			$('.js-selectBirth-day').append('<option value="">日</option>');

			if($('.js-selectBirth-year').val() && $('.js-selectBirth-month').val()) {
				let dateHTML = '';
				for(let i=1; i <= 31; i++) {
					let thisDateStr =
					`${$('.js-selectBirth-year').val().slice(0, 4)}-${('0'+$('.js-selectBirth-month').val().slice(0, -1)).slice(-2)}-${('0'+i).slice(-2)}`;
					if(new Date(thisDateStr).getMonth() + 1 === Number($('.js-selectBirth-month').val().slice(0, -1)) && new Date(thisDateStr) < thisDate) {
						dateHTML += `<option value="${i}日">${i}日</option>`;
					}
				}
				$('.js-selectBirth-day').append(dateHTML);
			}
		};

		// 100年前まで選択可能
		let yearHTML = '';
		$('.js-selectBirth-year').append('<option value="">西暦</option>');
		for (let i = 100; i >= 0; i--) {
			yearHTML += `<option value="${thisYear - i}年">${thisYear - i}年</option>`;
		}
		$('.js-selectBirth-year').append(yearHTML);

		$('.js-selectBirth-year').change(() => {
			$('.js-selectBirth-month').val('');
			setDateOption();
			sessionStorage.setItem('form-birthYear', $('.js-selectBirth-year').val());
		});
		$('.js-selectBirth-month').change(() => {
			setDateOption();
		});

		if (sessionStorage.getItem('form-birthYear')) {
			$('.js-selectBirth-year').val(sessionStorage.getItem('form-birthYear'));
		}
	};

	// チェックボックスとinputを連動
	const checkSubInput = () => {
		$('.js-checkSubInput').each((idx, ele) => {
			if ($(ele).find('input[type="checkbox"]').prop('checked')) {
				$(ele).find('.inquiry-checkSubInput input').prop('disabled', false);
			}

			$(ele).find('input[type="checkbox"]').change((e) => {
				if ($(e.currentTarget).prop('checked')) {
					$(ele).find('.inquiry-checkSubInput input').prop('disabled', false);
				} else {
					$(ele).find('.inquiry-checkSubInput input').prop('disabled', true);
				}
			});
		});
	};

	// ＜ゴルフスクール／テニススクールについてのお問い合わせ＞クエリストリングからお問い合わせ内容選択
	const selectContentFromQuery = () => {
		const search = location.search;
		const searchArr = search.split('&');
		let val;
		for (let i = 0; i < searchArr.length; i++) {
			if (searchArr[i].indexOf('content') !== -1) {
				val = searchArr[i].split('=')[1];
			}
		}
		switch(val) {
			case'school': $('.js-select-content').val('スクールに関するお問い合わせ'); break;
			case'recruit': $('.js-select-content').val('採用に関するお問い合わせ'); break;
			case'fc': $('.js-select-content').val('フランチャイズに関するお問い合わせ'); break;
			default: $('.js-select-content').val('スクールに関するお問い合わせ');
		}
	};

	// ＜ゴルフスクール＞体験申込みフォーム：都道府県からスクール一覧取得
	const setGolfSchoolList = () => {

		// 都道府県リストを取得して、都道府県名を表示する
		$.getJSON('/golfschool/ajax/school/prefecture/list.json', (data) => {
			let prefectureHTML = '<option value="">都道府県を選択してください</option>';
			if (data.rt_bn_prefecture_list && data.rt_bn_prefecture_list.length) {
				data.rt_bn_prefecture_list.forEach((prefecture) => {
					if (prefecture.cf_s_prefecture) {
						prefectureHTML += `<option value="${prefecture.cf_s_prefecture_code}">${prefecture.cf_s_prefecture}</option>`;
					}
				});
				$('.js-selectShop-pref').html(prefectureHTML);
				$('.js-selectShop-pref').attr('disabled', false);

				// クエリストリングがある場合、スクールを選択した状態にする
				if (location.search.indexOf('pref') !== -1) {
					const searchArr = location.search.slice(1).split('&');
					let pref = '', schoolName = '';
					for (let i = 0; i < searchArr.length; i++) {
						if (searchArr[i].split('=')[0] === 'pref') {
							pref = decodeURIComponent(searchArr[i].split('=')[1]);
						} else if (searchArr[i].split('=')[0] === 'school') {
							schoolName = decodeURIComponent(searchArr[i].split('=')[1]);
						}
					}
					$('.js-selectShop-pref').find('option').each((idx, ele) => {
						if ($(ele).text() === pref) {
							$('.js-selectShop-pref').val($(ele).attr('value'));
							setSelectSchool($(ele).attr('value'), schoolName);
							sessionStorage.setItem('form-golfSchoolEntry-shopPref', $(ele).attr('value'));
						}
					});
				} 
				else if (sessionStorage.getItem('form-golfSchoolEntry-shopPref') && sessionStorage.getItem('form-golfSchoolEntry-shopName')) {
					// 確認画面から戻った場合等はsessionStorageを取得
					$('.js-selectShop-pref').val(sessionStorage.getItem('form-golfSchoolEntry-shopPref'));
					setSelectSchool(sessionStorage.getItem('form-golfSchoolEntry-shopPref'), sessionStorage.getItem('form-golfSchoolEntry-shopName'));
				}
			} 
		});

		const getJSONGolfSchoolList = (_prefID) => {
			return $.getJSON(`/golfschool/ajax/school/${_prefID}.json`);
		};

		const setSelectSchool = (_prefID, _schoolName) => {
			getJSONGolfSchoolList(_prefID).then((data) => {
				if (data.rt_bn_shop_list.length) {
					let shopListArr = data.rt_bn_shop_list;

					// カナ順でソート
					shopListArr.sort((a, b) => {
						if (a.cf_s_shop_sname_kana < b.cf_s_shop_sname_kana) return -1;
						if (a.cf_s_shop_sname_kana > b.cf_s_shop_sname_kana) return 1;
						return 0;
					});

					// selectセット
					let optionHTML = '';
					for (let i = 0; i < shopListArr.length; i++) {
						if (shopListArr[i].cf_s_from_web === '1') {
							const shopName = shopListArr[i].cf_s_shop_sname;
							const shopLink = shopListArr[i].cf_s_shop_sname_url; // Added shop_link field
							optionHTML += `<option value="${shopName}" data-link="${shopLink}">${shopName}</option>`;
						}
					}

					if (optionHTML) {
						optionHTML = '<option value="">スクールを選択してください</option>' + optionHTML;
						$('.js-selectShop-shop').html(optionHTML); // HTMLを置換するために.html()を使用する
						$('.js-selectShop-shop').attr('disabled', false);
					} else {
						// Web選択可能なスクールが存在しない場合
						$('.js-selectShop-shop').html('<option value="">選択可能なスクールがありません</option>');
					}

					// 選択時の処理
					const setContent = (_ele) => {
						$('.js-selectContent_gbi').addClass('di_none');
						$('.js-selectContent_gbi').find('input').prop('checked', false);
						$('.js-selectContent_junior').addClass('di_none');
						$('.js-selectContent_junior').find('input').prop('checked', false);
						$('.js-timetable').addClass('di_none').attr('href', '');

						// 他のリンクを非表示にする
						$('.js-selectShop-shopLink').empty();

						const selectShopName = $(_ele).val();
						for (let i = 0; i < shopListArr.length; i++) {
							if (selectShopName === shopListArr[i].cf_s_shop_sname) {
								let thisShop = shopListArr[i];
								$('.js-timetable').removeClass('di_none');
								$('.js-timetable').attr(
									'href',
									`/store_file/file/${thisShop.cf_s_attachment_file}`
								);
								for (let j = 0; j < thisShop.cf_s_tags.length; j++) {
									if (thisShop.cf_s_tags[j].cf_st_name_d === 'ジュニアスクール') {
										$('.js-selectContent_junior').removeClass('di_none');
									}
								}
							}
						}
						const selectShopLink = $(_ele).find(':selected').data('link');
						$('.js-selectShop-shopLink').append(`<a href="${selectShopLink}" target="_blank" class="td_under lh_10">スクールの詳細を見る</a>`);

						sessionStorage.setItem('form-golfSchoolEntry-shopName', selectShopName);
						sessionStorage.setItem('form-golfSchoolEntry-shopLink', selectShopLink);

						// お申込内容をsessionStorageに保存
						$('#content_01, #content_02, #content_03').on('change', (e) => {
							if ($(e.currentTarget).prop('checked')) {
								sessionStorage.setItem('form-golfSchoolEntry-content', $(e.currentTarget).attr('id'));
							}
						});
						if (sessionStorage.getItem('form-golfSchoolEntry-content')) {
							$(`#${sessionStorage.getItem('form-golfSchoolEntry-content')}`).prop('checked', true);
						}
					};

					// 初期選択がある場合、setContentを呼び出す
					if (_schoolName) {
						$('.js-selectShop-shop').val(_schoolName);
						setContent($('.js-selectShop-shop'));
					}

					// セレクトボックスのchangeイベントでsetContentを呼び出す
					$('.js-selectShop-shop').on('change', () => {
						// 選択されたときにsessionStorageをリセット
						sessionStorage.removeItem('form-golfSchoolEntry-content');
						$('#content_01').prop('checked', true);
						setContent($('.js-selectShop-shop'));
					});

				} else {
					// JSON取得できなかった場合
					$('.js-selectShop-shop').html('<option value="">選択可能なスクールがありません</option>');
					$('.js-selectShop-shopLink').empty(); // リンクも空にする
				}
			});
		};

		// 都道府県の選択イベント
		$('.js-selectShop-pref').on('change', (e) => {
			// 選択されたときにsessionStorageをリセット
			sessionStorage.removeItem('form-golfSchoolEntry-shopPref');
			sessionStorage.removeItem('form-golfSchoolEntry-shopName');
			sessionStorage.removeItem('form-golfSchoolEntry-content');
			$('#content_01').prop('checked', true);

			// 初期化
			$('.js-selectShop-shop').html('<option value=""></option>'); 
			$('.js-selectShop-shopLink').empty(); 
			$('.js-selectContent_junior').addClass('di_none');
			$('.js-selectContent_junior').find('input').prop('checked', false);

			const prefID = $(e.currentTarget).val();
			if (prefID) {
				setSelectSchool(prefID);
				sessionStorage.setItem('form-golfSchoolEntry-shopPref', prefID);
			}
		});
		
	};

	// ＜テニススクール＞体験申込みフォーム：スクール一覧取得
	const setTennisSchoolList = () => {
		const getJSONTennisSchoolList = () => {
			return $.getJSON('/tennisschool/ajax/school.json');
		};
		getJSONTennisSchoolList().then((data) => {
			if (data.rt_bn_shop_list.length) {
				let shopListArr = data.rt_bn_shop_list;

				// selectセット
				let optionHTML = '';
				for (let i = 0; i < shopListArr.length; i++) {
					optionHTML += `<option value="${shopListArr[i].cf_s_shop_sname}">${shopListArr[i].cf_s_shop_sname}</option>`;
				}
				$('.js-selectShop-shop').append(optionHTML);

				// 選択時、ソフトテニススクール／ジュニアレッスンを有効化する＆タイムテーブルPDFを設定
				const setContent = (_ele) => {
					$('.js-selectContent_soft').addClass('di_none');
					$('.js-selectContent_soft').find('input').prop('checked', false);
					$('.js-selectContent_junior').addClass('di_none');
					$('.js-selectContent_junior').find('input').prop('checked', false);
					$('.js-timetable').addClass('di_none').attr('href', '');
					$('.js-timetable_junior').addClass('di_none').attr('href', '');

					const selectShopName = $(_ele).val();
					for (let i=0; i<shopListArr.length; i++) {
						if (selectShopName === shopListArr[i].cf_s_shop_sname) {
							let thisShop = shopListArr[i];
							$('.js-timetable').removeClass('di_none');
							$('.js-timetable').attr(
								'href',
								`https://${thisShop._key}.tennis-school.co.jp/ts/${thisShop._key}/schedule/lesson_${thisShop._key}.pdf`
							);
							for (let j=0; j<thisShop.cf_s_tags.length; j++) {
								if (thisShop.cf_s_tags[j].cf_st_name_d === 'ソフトテニススクール') {
									$('.js-selectContent_soft').removeClass('di_none');
								}
								if (thisShop.cf_s_tags[j].cf_st_name_d === 'ジュニア') {
									$('.js-selectContent_junior').removeClass('di_none');
									$('.js-timetable_junior').removeClass('di_none');
									$('.js-timetable_junior').attr(
										'href',
										`https://${thisShop._key}.tennis-school.co.jp/ts/${thisShop._key}/schedule/lesson_jr_${thisShop._key}.pdf`
									);
								}
							}
						}
					}
					// sessionStorageに登録
					sessionStorage.setItem('form-tennisSchoolEntry-shopName', selectShopName);

					// 選択したお申込内容もsessionStorageに
					$('#content_01, #content_02, #content_03, #content_04, #content_05').on('change', (e) => {
						if($(e.currentTarget).prop('checked')) {
							sessionStorage.setItem('form-tennisSchoolEntry-content', $(e.currentTarget).attr('id'));
						}
					});
					if(sessionStorage.getItem('form-tennisSchoolEntry-content')) {
						$(`#${sessionStorage.getItem('form-tennisSchoolEntry-content')}`).prop('checked', true);
					}
				};

				// 初期値選択 呼び出し元＞セッションストレージ の順で優先
				let schoolName;
				if (sessionStorage.getItem('form-tennisSchoolEntry-shopName')) {
					schoolName = sessionStorage.getItem('form-tennisSchoolEntry-shopName');
				}
				if ($('.rt_school_id').text()) {
					schoolName = $('.rt_school_id').text();
				}
				if (schoolName) {
					$('.js-selectShop-shop').val(schoolName);
					setContent($('.js-selectShop-shop'));
				}
				$('.js-selectShop-shop').on('change', () => {
					setContent($('.js-selectShop-shop'));
				});

			} else {
				// JSON取得できなかった場合
				$('.js-selectShop-shop').append('<option value="">選択可能なスクールがありません</option>');
			}
		});
	};
	// ＜テニススクール＞体験申込みフォーム：スクールごとに確認画面のPOST先を変更する
	const setSendmailTennisSchool = () => {
		const $form = $('#form_sendmail');
		switch ($('.shopName').text()) {
		case 'ダンロップインドアテニススクール常盤平':
			$form.attr('action', '/tennisschool/entry/form/tokiwadaira/sendmail'); break;
		case 'ダンロップインドアテニススクール荻窪':
			$form.attr('action', '/tennisschool/entry/form/ogikubo/sendmail'); break;
		case 'ダンロップインドアテニススクール根岸':
			$form.attr('action', '/tennisschool/entry/form/negishi/sendmail'); break;
		case 'ダンロップテニススクール緑':
			$form.attr('action', '/tennisschool/entry/form/midori/sendmail'); break;
		case 'マリンテニスパーク・北村ダンロップテニススクール':
			$form.attr('action', '/tennisschool/entry/form/kitamura/sendmail'); break;
		case 'ダンロップテニススクール六甲アイランド':
			$form.attr('action', '/tennisschool/entry/form/rokko/sendmail'); break;
		case 'ダンロップテニススクール神戸総合運動公園':
			$form.attr('action', '/tennisschool/entry/form/kobe-sougou/sendmail'); break;
		case 'ダンロップ泉パークタウンテニスクラブ':
			$form.attr('action', '/tennisschool/entry/form/izumiparktowntc/sendmail'); break;
		default:
			$form.attr('action', '/tennisschool/entry/form/tokiwadaira/sendmail');
		}
	};

	// -- ▲ functions ▲ -------------------------------------------------------------------
	// ------------------------------------------------------------------------------------

	if($('.js-selectBirth').length) {
		setSelectDateBirth();
	}
	if($('.js-checkSubInput').length) {
		checkSubInput();
	}
	if((mapSite === 'golfschool' || mapSite === 'tennisschool') && location.search.indexOf('content') !== -1) {
		selectContentFromQuery();
	}
	if(mapSite === 'golfschool') {
		setGolfSchoolList();
	} else if(mapSite === 'tennisschool') {
		if($('.js-selectShop-shop').length) {
			setTennisSchoolList();
		}
		if(DUNLOP.va.pathname.indexOf('/entry/form/confirm.html') !== -1) {
			setSendmailTennisSchool();
		}
	}

})(window.jQuery, window.DUNLOP);
